module.exports = __webpack_public_path__ + "static/img/product_img_2.5deea73.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/product_img_2.png
// module id = qwsP
// module chunks = 22